export class AccountEntity {
  constructor() {
    this.id = null;
    this.type = null;
    this.number = null;
    this.sortcode = null;
    this.accountNumber = null;
    this.product = null;
    this.actionsAvailable = null;
    this.bank_id = null;
    this.metadata = null;
    this.displayName = null;
    this.balances = null;
    this.code = null;
    this.showIcon = null;
    this.display_order = null;
    this.accountName = null;
  }
  setShowIcon(Icon) {
    this.showIcon = Icon;
  }
}
export default AccountEntity;
